module.exports = __webpack_public_path__ + "static/pipes_of_the_sewers-d63f6b15125faa15adedcdc6cf000022.jpeg";